import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import HRule from '../../atoms/HRule'
import Subtitle from '../../atoms/Subtitle'

import { RuleWrapper } from './wrappers'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const AlternativeRuler = props => {
  const { subtitle } = props
  return (
    <Content>
      <RuleWrapper>
        <HRule text="ou" />
      </RuleWrapper>
      {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Content>
  )
}

AlternativeRuler.propTypes = {
  subtitle: PropTypes.string,
}

export default AlternativeRuler
